import axios from 'axios';

const api = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: `Basic ${window.btoa('cheppers:chpdemo')}`,
    'Access-Control-Allow-Origin': '*',
  },
});

export const getData = url => api.get(url).then(response => response.data);
